<template>
  <div id="app">
    <h1> Références à surveiller </h1>
    <h3>Risque de rupture à terme</h3>
    <span>Filtrer par risque:</span>
    <div>
    <b-button-group>
      <b-button @click="filterOnlyEmergency()" variant="primary">Fort</b-button>
      <b-button @click="filterOnlyOrderQuick()" variant="primary">Probable </b-button>
    </b-button-group>
    </div>
    <!-- <br>
    <b-button variant="success" @click="resetList()">
      Toutes les références
    </b-button> -->
    <div class="list-wrapper">
      <div v-if="isBusy" class="text-center text-danger my-2">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <b-list-group v-if="!isBusy">
      <b-list-group-item
        v-for="(ref, index) in productList" :key="index"
        v-if="ref.risk > 1"
        class="flex-column align-items-start"
        v-bind:class="{ activeandon: ref.orderNow, mediumeandon: ref.orderQuick  }"
      >
        <div class="d-flex w-100 justify-content-between">
          <div class="col-left align-middle">
            <b>{{displayRef(ref.code)}}</b> &emsp; {{ref.designation}} {{ref.count}} &emsp;
          </div>
          <div class="d-flex col-right">
            <div>
              <span class="andon-alert text-center" v-if="ref.lowStock"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> </span>
              <span v-if="ref.lowStock">Plus de stock</span>
              <span class="andon-alert text-center" v-if="ref.orderNow"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> </span>
            </div>
            &emsp;
            <div>
              <b-badge pill variant="info">{{ref.supermarket_emplacement}}</b-badge>
            </div>
            &emsp;
            <!-- <span class="andon"></span> -->
            <b-button
              @click="displayDetails(index)"
              pill
              variant="light"
              style="background-color: white; border-color: white"
            >
              <i class="fa fa-chevron-down"></i>
            </b-button>
          </div>
        </div>
        <div v-show="ref.showDetails" class="row details-reference">
          <b-table
            :bordered="true"
            :outlined="true"
            :fields="[{ key: 'card_nb', label: 'Nombre de cartes' },
                      { key: 'batch_size', label: 'Taille de lot' },
                      { key: 'lead_time_conso', label: 'Lead Time consommation' },
                      { key: 'lead_time_approv', label: 'Lead Time approvisionnement' },
                      { key: 'lead_time_order', label: 'Lead Time commandé' },
                      { key: 'takt_time', label: 'Takt time de consommation' },
                      { key: 'seconds_since_last_scan', label: 'Dernier scan' },        
                      { key: 'ranking', label: 'Rank' },        
                      'action'
                    ]"
            :items="[{ card_nb: ref.nbr_card,
                       batch_size: ref.batch_size,
                       lead_time_conso: ref.lead_time_consum,
                       seconds_since_last_scan: ref.seconds_since_last_scan,
                       ranking: ref.ranking,
                       takt_time: ref.takt_time,
                       lead_time_approv: ref.lead_time_appro,
                       lead_time_order: ref.lead_time_order}]"
            :class="{ activeandon: ref.orderNow, mediumeandon: ref.orderQuick  }"
          >
            <template v-slot:cell(action)="">
              <b-button variant="primary" @click="goTo('/andon/'+ref.code)">Hippodrome</b-button>
            </template>
          </b-table>
        </div>
      </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>
<script>

import server from '../../api/server.vue'
import apiReference from '../../api/reference.vue'
import { Steps } from '../../core/services/steps.js'


export default {
  name: 'ProductAndonMethod',
  components: {},
  data () {
    return {
      productList: [],
      productListCopy: [],
      sumNow: 0,
      sumQuick: 0,
      totalAndons: 0,
      steps: JSON.parse(JSON.stringify(Steps)),
      isBusy: false,
      lastIndexDetails: 0,
      debounce: true,
    }
  },
  methods: {
    displayRef (reference) {
      return this.chunk(reference, 3).join(' ')
    },
    chunk (str, n) {
      let ret = []
      let len = str.length
      for (let i = 0; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    },
    getReferenceDanger () {
      this.isBusy = true
      apiReference.getExternalLoopReferences().then(result => {
        var data = result.data.references
        var filteredList = []
        for (const obj in data) {
          var lead_time_appro = data[obj].lead_time_appro
          var lead_time_consum = data[obj].lead_time_consum
          var lead_time_order = data[obj].lead_time_order
          // && data[obj].ranking === ('A' || 'B')    add if only A and B product needs to be assessed
          if (typeof(data[obj].lead_time_appro) === 'number' &&
              typeof(data[obj].lead_time_consum) === 'number' &&
              data[obj].seconds_since_last_scan > 0 &&
              (data[obj].takt_time > 0 || lead_time_order > 0 || lead_time_appro > 0)  &&
              (data[obj].supermarket_emplacement[0] === 'S')){
            if (data[obj].code === 'TES001Z01') { // carte test API - IT
              continue
            }
            if (data[obj].seconds_since_last_scan < 600) {
              continue
            }
            this.getMarginToOrder(data[obj])
            data[obj].risk = 1
            if (this.IsAnEmergency(data[obj])) {
              data[obj].orderNow = true
              // risk for sorting purpose. 
              data[obj].risk = 3
            } else if (this.needToBeChecked(data[obj])) {  
              data[obj].risk = 2
              data[obj].orderNow = false
              data[obj].orderQuick = true
            }
            if (lead_time_consum !== 0 &&  lead_time_consum < (lead_time_order + lead_time_appro)) {   
              data[obj].showDetails = false
              data[obj].lead_time_appro = (data[obj].lead_time_appro / 3600 / 24).toFixed(1) + " J"
              data[obj].lead_time_order = (data[obj].lead_time_order / 3600 / 24).toFixed(1) + " J"
              data[obj].lead_time_consum = (data[obj].lead_time_consum/ 3600 / 24).toFixed(1) + " J"
              data[obj].seconds_since_last_scan = (data[obj].seconds_since_last_scan/ 3600 / 24).toFixed(1) + " J"
              data[obj].takt_time = (data[obj].takt_time/ 3600 / 24).toFixed(1) + " J"
              if (!data[obj].orderQuick || !data[obj].orderNow) {
                this.getReferencesCards(data[obj])
              }
              filteredList.push(data[obj])
            }
          }
        }
        filteredList.sort(function(a, b) {
          var x = a.supermarket_emplacement.toLowerCase();
          var y = b.supermarket_emplacement.toLowerCase();
          if (x < y) {return -1;}
          if (x > y) {return 1;}
          return 0
        })
        // this.totalAndons = filteredList.length
        this.productList = filteredList
        this.isBusy = false
      })
      .catch(err => {
          console.log(err)
      })
      this.setProtectedTimeout(this.getReferenceDanger, 300000)   // 5 minutes
    },
    displayDetails (index) {
      if (index !== this.lastIndexDetails) {
        this.productList[this.lastIndexDetails].showDetails = false
      }
      this.productList[index].showDetails = !this.productList[index].showDetails
      this.lastIndexDetails = index
    },
    isStockEmpty (ref) {
      if (ref.cardCount === 0) {
        if (ref.orderQuick) {
          return
        } else if (ref.orderNow) {
          return
        } else {
          ref.orderQuick = true
          ref.orderNow = false
          ref.risk = 2
          return
        }
      }
    },
    getReferencesCards (ref) {
      let cardCount = 0
      server.getCardFromReference(ref.code, 'loop_external').then(result => {
        ref.cards = result.data.cards
        const cards = ref.cards
        for ( const card in cards) {
          if (cards[card].last_workstation && cards[card].last_workstation.name === 'En Stock') {
            cardCount +=1
          }
        }
        ref.cardCount = cardCount 
        if (ref.cardCount === 0) {
          ref.orderNow = true
          ref.lowStock = true
          ref.orderQuick = false
          ref.risk = 3
          return
        }
        if (ref.cardCount >= ref.nbr_card) {
          ref.orderNow = false
          ref.risk = 1
        }
      this.isStockEmpty(ref)
      })
    },
    
    IsAnEmergency (ref) {
      // ref.seconds_since_last_scan < (60 * 60 * 24 * 30) => check if the card have been use in the past month
      // ref.takt_time * ref.nbr_card) < ref.lead_time_appro => check if we can have a new procuct before finish those is stock
      return ((ref.takt_time * ref.nbr_card) < (ref.lead_time_appro)) &&
             ((ref.lead_time_consum * ref.nbr_card) < (ref.lead_time_appro + ref.lead_time_order))
    },
    needToBeChecked (ref) {
      return (ref.marginToOrder > 0 && ref.marginToOrder < 5)
    },
    getMarginToOrder (ref) {
      ref.marginToOrder = ((ref.lead_time_appro / 3600 / 24) + (ref.lead_time_order / 3600 / 24)) -
                                  (((ref.takt_time/ 3600 / 24) * ref.nbr_card))

    },
    filterOnlyEmergency () {
      const result = []
      if (this.productListCopy.length > 1) {
        this.productList = this.productListCopy
      }
      this.productList.forEach(element => {
        if (element.orderNow) {
        // if (element.orderNow) {
          result.push(element)
        }
      })
      this.productListCopy = this.productList
      this.productList = result
    },
    filterOnlyOrderQuick () {
      const result = []
      if (this.productListCopy.length > 1) {
        this.productList = this.productListCopy
      }
      this.productList.forEach(element => {
        if (element.orderQuick) {
          result.push(element)
        }
      })
      this.productListCopy = this.productList
      this.productList = result
    },
    resetList () {
      if (this.productListCopy.length > 1) {
        this.productList = this.productListCopy
      }
      this.debounce = true
    },
    
  },
  mounted: function () {
    this.getReferenceDanger()
  },
}

</script>

<style type="text/css" scoped>
.list-wrapper {
  width: 100%;
  margin-top: 5%;
}

.andon {
  height: 30px;
  width: 30px;
  /* // margin: 6%; */
  background-color: #F6AB6C;
  border: none;
  border-radius: 50%;
  display: inline-block;
}

.details-reference {
  margin-top: 3%;
  border-top: 2px solid #dee2e6;
}

.col {
  padding: 1rem;
}

.andon-alert {
  color: white;
  font-size: 30px;
}

.activeandon {
  background-color: #F6AB6C;
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.mediumeandon {
  background-color: #F6EFA6;
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.747);
}
</style>



// WEBPACK FOOTER //
// src/components/andon/ProductAndonMethod.vue